import { createSelector } from "@reduxjs/toolkit";

export const hearingDatesListState = (state) => state.hearingDatesList;

export const HearingDatesListSelectors = createSelector(hearingDatesListState, (state) => state);
